import React, { useCallback, useContext } from "react";

import { Site } from "../../../../../dtos/site";
import { RequestState } from "../../../../../enums/requestState";
import SignalRContext from "../../../../../signalr/context";
import { ButtonWithConfirm } from "../../../../ButtonWithConfirm";
import { useApi } from "../../../../useApi";

import { actionButtonStyle } from "./actionButtonStyle";
import { useRestartAction } from "./useRestartAction";

const buttonLabels: { [key in RequestState]: string; } = {
    [RequestState.Idle]: "Restart",
    [RequestState.Requesting]: "Requesting...",
    [RequestState.Processing]: "Restarting biometric device...",
}

interface Props {
    site: Site;
}

export function RestartBiometricDeviceButton({ site }: Props) {
    const { siteApi } = useApi();
    const { restartBiometricDeviceCompleted } = useContext(SignalRContext);

    const request = useCallback(() => siteApi.restartBiometricDevice(site.id), [siteApi, site.id]);

    const { requestState, trigger } = useRestartAction({
        siteId: site.id,
        request,
        ack: restartBiometricDeviceCompleted,
        requestErrorMessage: "ERROR: Failed to request biometric device restart",
        // The reader only picks the command up on its next heartbeat poll, so the physical
        // restart lags this acknowledgement.
        successMessage: "Restart command queued for biometric device",
        failureMessage: "ERROR: No biometric device is connected",
    });

    return (
        <ButtonWithConfirm
            confirmDialogContent="Are you sure you want to restart the biometric device?"
            confirmedCallback={trigger}
            disabled={requestState !== RequestState.Idle}
            style={actionButtonStyle}
        >
            {buttonLabels[requestState]}
        </ButtonWithConfirm>
    );
}
